/**
 * Har JS error server par bhej deta hai.
 *
 * Pi Browser mein console nahi hai - error hoti hai to sirf blank
 * screen milti hai aur wajah kabhi maloom nahi hoti. Ab har error
 * server ke log mein aa jayegi:
 *
 *   tail -f /var/log/penflow_js_errors.log
 */

let sent = 0;
const MAX = 12;          // ek page-load par itni se zyada nahi
const seen = new Set();

// Browser ki apni shor - hamare code se koi taalluq nahi.
// Pi Browser (Android WebView) ye rozana bhejta hai.
const NOISE = [
  'Messaging promise',
  'message channel closed',
  'Extension context invalidated',
  'ResizeObserver loop',
  'Script error.',
  'chrome-extension://',
  'Non-Error promise rejection',
  'Load failed',
  'Failed to fetch',
  'NetworkError when attempting',
];

function isNoise(msg) {
  const m = String(msg || '');
  for (let i = 0; i < NOISE.length; i += 1) {
    if (m.indexOf(NOISE[i]) >= 0) return true;
  }
  return false;
}

function report(payload) {
  if (sent >= MAX) return;
  if (isNoise(payload.message)) return;

  // wohi error bar bar na bhejo
  const key = (payload.message || '') + '|' + (payload.line || '');
  if (seen.has(key)) return;
  seen.add(key);
  sent += 1;

  try {
    const token = localStorage.getItem('token') || '';
    fetch('/api/js-error/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Token ${token}` } : {}),
      },
      body: JSON.stringify({ ...payload, url: window.location.href }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {}
}

export function installErrorLogger() {
  window.addEventListener('error', (e) => {
    report({
      kind: 'error',
      message: e.message || String(e.error || 'Unknown error'),
      source: e.filename || '',
      line: e.lineno,
      col: e.colno,
      stack: (e.error && e.error.stack) || '',
    });
  });

  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    report({
      kind: 'promise',
      message: (r && (r.message || String(r))) || 'Unhandled promise rejection',
      stack: (r && r.stack) || '',
    });
  });
}

export default installErrorLogger;
